// extracted by mini-css-extract-plugin
export default {"modal":"ZSQeLS","removeButton":"_mrnYy"};